//const declarations
const WEEK_DAYS = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY'];
const WEEK_ENDS = ['SATURDAY', 'SUNDAY'];
const ALL_DAYS = WEEK_DAYS.concat(WEEK_ENDS)
//default data source for available working hours
const AVAILABLE_HOURS_SOURCE = {
    'MONDAY': {
        from: '',
        to: '',
    },
    'TUESDAY': {
        from: '',
        to: ''
    },
    'WEDNESDAY': {
        from: '',
        to: ''
    },
    'THURSDAY': {
        from: '',
        to: ''
    },
    'FRIDAY': {
        from: '',
        to: ''
    },
    'SATURDAY': {
        from: '',
        to: ''
    },
    'SUNDAY': {
        from: '',
        to:''
    },
}

//get the next available time
//this will be used if current time is not part of the working hours
export function getNextAvailableTime(DateTime, timezone, availability, defaultLanguage = 'en') {
    setAvialibilityHoursForTheGivenDay(availability);
    let today = DateTime.local().setZone(timezone);
    let todayInEnglishLocale = DateTime.local().setZone(timezone).setLocale("en");
    let isItBusinesHr =  isItWorkingHour(todayInEnglishLocale, timezone, DateTime);
    if(isItBusinesHr){
        return { 
            success: true,
            isItWorkingHour: true,
            agentWillBeBackAt: today.setLocale(defaultLanguage),
            agentWillBeBackIn:null
        };
    }
    for(let i=0; i<=7; i++) {
        // const nextAvailableTime =  new Date(today.getFullYear(), today.getMonth(), today.getDate() + actualDayInWeek - (today.getDay() >= actualDayInWeek ? today.getDay() - 7 : today.getDay()));
        const nextAvailableTime =  todayInEnglishLocale.plus({days: i});
        const availableHours =  getAvialibilityHoursForTheGivenDay(nextAvailableTime.weekdayLong.toUpperCase());
        
        //skip if day doesn't have working hours
        //Means Agent won't come to online during this day
        //so directly check in the next day
        if(!availableHours || !availableHours.from)
            continue;
        
        //if day has working hours
        //calculate the distance between the current hour and the starting 
        //working hour which is mentioned 
        const availableTime = availableHours.from.split(':');
        
        let timeStamp = {
            year: nextAvailableTime.year,
            month: nextAvailableTime.month,
            day: nextAvailableTime.day,
            hour: parseInt(availableTime[0]),
            minute: parseInt(availableTime[1]),
            zone: timezone,
        }
        //exact start time of the agent
        const agentWillBeBackAt = DateTime.fromObject(timeStamp)
        //calculate the distance in hours
        const agentWillBeBackIn = agentWillBeBackAt.diff(today, ['hours'])
        //skip if the time is already expired
        //Mainly exculdes the today situation
        if((parseFloat(agentWillBeBackIn.values.hours).toFixed(2))<=0) continue;
        //otherwise return the full data
        return { agentWillBeBackAt: agentWillBeBackAt.setZone('local').setLocale(defaultLanguage), success:true, agentWillBeBackIn, isItWorkingHour: false };
    
    }
    //mostaly this situation should'nt occur
    //because atleast one day should have working hours
    return { success: false}
}

//setter to get the working hours for the GIVEN DAY
/*
INPUT PARAMS
@dayName , EX: 'SUNDAY' or 'WEEKDAYS'
@from : '08:30'
@to: '17:30';
*/
function setBusinnessHoursStore({
    startTime, endTime, selectedDay
}) {
    const dayName = selectedDay.toUpperCase()

    if(dayName === 'WEEKDAYS') {
        for(let day of WEEK_DAYS) {
            AVAILABLE_HOURS_SOURCE[day].from = startTime;
            AVAILABLE_HOURS_SOURCE[day].to = endTime;  
        }
        return;
    }
    if(dayName === 'WEEKENDS') {
        for(let day of WEEK_ENDS) {
            AVAILABLE_HOURS_SOURCE[day].from = startTime;
            AVAILABLE_HOURS_SOURCE[day].to = endTime;  
        }
        return;
    }
    if(dayName === 'EVERYDAY' || dayName === 'EVERY DAY') {
        for(let day of ALL_DAYS) {
            AVAILABLE_HOURS_SOURCE[day].from = startTime;
            AVAILABLE_HOURS_SOURCE[day].to = endTime;  
        }
        return;
    }
   
    //if invalid day name provided 
    //return it
    if(!AVAILABLE_HOURS_SOURCE[dayName])
        return;
    
    AVAILABLE_HOURS_SOURCE[dayName].from = startTime;
    AVAILABLE_HOURS_SOURCE[dayName].to = endTime;
}
export function setAvialibilityHoursForTheGivenDay({startTime, endTime, selectedDay, extraBusinessHours = []}) {

    // default business hours
    setBusinnessHoursStore({
        startTime, endTime, selectedDay
    })
    //if user adds more business hours, Override the previous business hour with the new one
    if(extraBusinessHours && extraBusinessHours.length > 0) {
        for(let businessHour of extraBusinessHours) {
            setBusinnessHoursStore(businessHour)
        }
    }

}
//getter to get the working hours for the GIVEN DAY
/*
INPUT PARAMS
@dayName , EX: 'SUNDAY'
OUTPUT
{from:'',to:''}
*/
export  function getAvialibilityHoursForTheGivenDay(dayName) {
    return AVAILABLE_HOURS_SOURCE[dayName] || { from: '', to: '' }
}

//check is it working hour 
//return true if yes otherwise false
export  function isItWorkingHour(today, timezone, DateTime) {
    const todayName = today.weekdayLong.toUpperCase();
    //get working hours for current time
    const availableHours =  getAvialibilityHoursForTheGivenDay(todayName);

    if(availableHours && availableHours.from && availableHours.to){
        //calcualte both from time and to time
        const availableTimeFrom = availableHours.from.split(':');
        const availableTimeTo = availableHours.to.split(':');
        //for from time
        let timeStamp = {
            hour: parseInt(availableTimeFrom[0]),
            minute: parseInt(availableTimeFrom[1]),
            zone: timezone
        }
        const fromTime = DateTime.fromObject(timeStamp)
        //to time
        timeStamp = {
            hour: parseInt(availableTimeTo[0]),
            minute: parseInt(availableTimeTo[1]),
            zone: timezone
        }
        const toTime = DateTime.fromObject(timeStamp)
        const isItBusinessHour =  today.ts >=fromTime.ts && today.ts <= toTime;
        //now should be in between start time and end time otherwise
        //its not working time
        //True: Working
        //False: Not Working
        return isItBusinessHour;
    }
    //return false when time is not availble
    return false;
}

//test driver
export  function testDriver() {
    console.log(getNextAvailableTime({}).nextAvailableTime.toTimeString())
    console.log(isItWorkingHour())
}
// console.log(getTimeInAgentTimeZone());